'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "component"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { ecx } from "../../utils.mjs";
/**
 * VisuallyHidden is a component that hides content visually but leaves it available to screen readers.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-visuallyhidden--docs) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/VisuallyHidden)
 */
export var VisuallyHidden = /*#__PURE__*/React.forwardRef(function VisuallyHidden(_ref, ref) {
  var as = _ref.as,
    component = _ref.component,
    props = _objectWithoutProperties(_ref, _excluded);
  var polymorphicProp = as ? as : component;
  var Element = polymorphicProp ? polymorphicProp : 'span';
  return /*#__PURE__*/React.createElement(Element, Object.assign({}, props, {
    className: ecx(['visually-hidden'], props.className),
    ref: ref,
    "data-encore-id": ENCORE_DATA_IDS.VisuallyHidden
  }));
});